import { CrudHeaderComponent } from '@admin/components';
import { Component } from '@angular/core';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [CrudHeaderComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {}
